<form-layout
    [showSave]="canSave"
    (onSave)="onSaveClick()"
    (onBack)="onBackClick()"
    (onNext)="onSaveAndNextClick()">

    <vertretungsberechtigte-form [form]="contactDataProcessStepForm"></vertretungsberechtigte-form>
</form-layout>
